export default __webpack_public_path__ + "img/elnlftGN.a85c819b.svg";